var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-control-plaintext"},[_vm._v(" "+_vm._s(_vm.value_)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }